import { ListeTable } from '@mairistem/liste';
import { newIdentifiant } from '@mairistem/tools';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import type { RegieRegisseurType } from '@/types';
import RegieRegisseurListeTableRow from './RegieRegisseurListeTableRow';

type RegieRegisseurListeTableProps = {
  regisseurs: RegieRegisseurType[];
  onRegisseurEdit: (regisseur: RegieRegisseurType) => void;
  onRegisseurRemove: (regisseur: RegieRegisseurType) => void;
};

const RegieRegisseurListeTable = (props: RegieRegisseurListeTableProps) => {
  const { regisseurs, onRegisseurEdit, onRegisseurRemove } = props;

  const [sorts, setSorts] = React.useState({});

  const handleSort = React.useCallback(
    (sort) => {
      setSorts(
        _.isEmpty(sort)
          ? // tri par défaut
            {
              actif: 'desc',
              nom: 'asc',
              prenom: 'asc',
            }
          : _.mapValues(sort, (val) => (val === 'ascending' ? 'asc' : 'desc')),
      );
    },
    [setSorts],
  );

  const renderRow = (item, __, rowProps) => (
    <RegieRegisseurListeTableRow
      item={item}
      onRegisseurEdit={onRegisseurEdit}
      onRegisseurRemove={onRegisseurRemove}
      rowProps={rowProps}
    />
  );

  const formatedRegisseurs = React.useMemo(
    () =>
      _.map(regisseurs, ({ identifiant, nom, prenom, ...rest }) => ({
        // Les nouveaux n'ont pas d'identifiant, mais la liste a besoin d'un identifiant
        identifiant: identifiant || newIdentifiant(),
        nom: _.upperFirst(_.toLower(nom)),
        prenom: _.upperFirst(_.toLower(prenom)),
        ...rest,
      })),
    [regisseurs],
  );

  const orderedRegisseurs = React.useMemo(
    () => _.orderBy(formatedRegisseurs, _.keys(sorts), _.values(sorts)),
    [formatedRegisseurs, sorts],
  );

  return (
    <div style={{ height: 250 }}>
      <ListeTable
        count={_.isEmpty(orderedRegisseurs) ? 0 : _.size(orderedRegisseurs)}
        items={orderedRegisseurs}
        noResultsMessage="Aucun régisseur"
        noResultsIcon="dont"
        loading={false}
        onSort={handleSort}
      >
        <ListeTable.Header>
          <ListeTable.Column name="nom" sortable width={12}>
            Nom et prénom
          </ListeTable.Column>
          <ListeTable.Column
            name="actif"
            sortable
            verticalAlign="middle"
            textAlign="center"
            width={4}
          >
            Actif
          </ListeTable.Column>
        </ListeTable.Header>
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </div>
  );
};

export default RegieRegisseurListeTable;
